import React from 'react'
import "./Whitepaper.css"
import white_paper from "../Assets/white_paper.png"
import { IoIosArrowRoundForward } from "react-icons/io";
import white from "../Assets/feaure_one.png"
import l_roc from "../Assets/left_roc.png"
import Pdf from '../Assets/whitepaper.pdf';


export default function Whitepaper() {
    return (
        <section className='main_white_paper position-relative' id='WHITEPAPER'>
        
            <div className="container">
                <div className="section_head gor_font text-center" data-aos="fade-up">Whitepaper</div>
                <div className="row z-2 position-relative mt-3  how_buy_box  h-auto align-items-center justify-content-between" data-aos="fade-up">
                    <div className="col-md-6" >
                    <div className="">

                        <img src={white_paper} className='w-100 h-100' alt="" />
                    </div>
                    </div>
                    <div className="col-md-5 mt-3 mt-md-0">
                        <div className="white_paper_content">
                            <p className='nor_font text-white fw-semibold text-start'>$RBT.network Coin is a digital cryptocurrency designed to combine the best aspects of security, speed, and accessibility for everyday users. Born out of a desire to create a decentralized currency that is easy to mine and fun to use, $RBT.network Coin offers a unique approach to digital finance. Whether you're new to cryptocurrencies or a seasoned veteran, $RBT.network Coin provides a straightforward way to get involved in the digital economy.</p>
                          <a href = {Pdf}  target = "_blank">   <button className='Red_btn nor_font fw-bold mt-5'>Read Whitepaper <IoIosArrowRoundForward className=' text-white fs-2' /></button> </a>
                        </div>
                    </div>
                </div>
            </div>
        <img src={white} className='faq_tur' style={{top:"1rem"}} alt="" />
        <img src={l_roc} className='d-none d-md-block l_roc' style={{width:"600px"}} alt="" />
        


        </section>
    )
}
